import {ToMatchOptions} from 'Shared/utilities/MapDiscriminatedUnion';

export class UnvalidSocialSecurityNumber {
  public readonly key = 'UnvalidSocialSecurityNumber';
  public readonly value = '';
}

export class InvalidSocialSecurityNumber {
  public readonly key = 'InvalidSocialSecurityNumber';

  constructor(public readonly value: string) {}
}

export class ValidSocialSecurityNumber {
  public static create(value: string) {
    const formattedValue = value.match(/\d/g)?.join('') || '';

    return formattedValue.length === 9 || formattedValue.length === 0
      ? new ValidSocialSecurityNumber(formattedValue)
      : new InvalidSocialSecurityNumber(formattedValue);
  }

  public readonly key = 'ValidSocialSecurityNumber';
  constructor(public readonly value: string) {}
}

export type SocialSecurityNumber = ValidSocialSecurityNumber | InvalidSocialSecurityNumber | UnvalidSocialSecurityNumber;

export type SocialSecurityNumberOptions<TReturn> = ToMatchOptions<SocialSecurityNumber, 'key', TReturn>;

export const matchSocialSecurityNumber = <TReturn>(
  socialSecurityNumber: SocialSecurityNumber,
  options: SocialSecurityNumberOptions<TReturn>
): TReturn => {
  switch (socialSecurityNumber.key) {
    case 'InvalidSocialSecurityNumber':
      return options.InvalidSocialSecurityNumber(socialSecurityNumber);
    case 'ValidSocialSecurityNumber':
      return options.ValidSocialSecurityNumber(socialSecurityNumber);
    case 'UnvalidSocialSecurityNumber':
      return options.UnvalidSocialSecurityNumber(socialSecurityNumber);
  }
};

export const EmptySocialSecurityNumber = new ValidSocialSecurityNumber('');

export const isValidSocialSecurityNumber = (
  socialSecurityNumber: SocialSecurityNumber
): socialSecurityNumber is ValidSocialSecurityNumber => socialSecurityNumber.key === 'ValidSocialSecurityNumber';

export const isEmptySocialNumber = (socialSecurityNumber: SocialSecurityNumber) : socialSecurityNumber is UnvalidSocialSecurityNumber => 
socialSecurityNumber.value.length === 0;